import { render, staticRenderFns } from "./oauthMicrosoft.vue?vue&type=template&id=087dcc26&"
import script from "./oauthMicrosoft.vue?vue&type=script&lang=js&"
export * from "./oauthMicrosoft.vue?vue&type=script&lang=js&"
import style0 from "./oauthMicrosoft.vue?vue&type=style&index=0&id=087dcc26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports